import { render, staticRenderFns } from "./ShareVideoProvider.vue?vue&type=template&id=23dfebfd&scoped=true&"
import script from "./ShareVideoProvider.vue?vue&type=script&lang=js&"
export * from "./ShareVideoProvider.vue?vue&type=script&lang=js&"
import style0 from "./ShareVideoProvider.vue?vue&type=style&index=0&id=23dfebfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dfebfd",
  null
  
)

export default component.exports